// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__183es","col":"CardReaderDesc_col__3NrOa","label":"CardReaderDesc_label__1glUf"};